export default __webpack_public_path__ + "static/media/logo-Growyx-workspace.c2be7442.svg";